import { z } from 'zod';

import type { AccountType } from '../generated/enums.js';

/** AP document-layer classification (AI / worker), distinct from GL `AccountType`. */
export const AccountingClassification = {
  EXPENSE: 'EXPENSE',
  COST: 'COST',
  LIABILITY: 'LIABILITY',
  ASSET: 'ASSET',
  'P&L': 'P&L',
  REVENUE: 'REVENUE',
} as const;

export type AccountingClassification =
  (typeof AccountingClassification)[keyof typeof AccountingClassification];

export const AccountingClassificationSchema = z.enum([
  'EXPENSE',
  'COST',
  'LIABILITY',
  'ASSET',
  'P&L',
  'REVENUE',
]);

/** Maps AP accounting classification to GL account types used for IA account filtering. */
export function resolveGlAccountTypesForAccountingClassification(
  accountingClassification?: string,
): AccountType[] {
  switch (accountingClassification) {
    case AccountingClassification.COST:
      return ['COGS', 'EXPENSE'];
    case AccountingClassification.EXPENSE:
      return ['COGS', 'EXPENSE'];
    case AccountingClassification.ASSET:
      return ['ASSET'];
    case AccountingClassification.LIABILITY:
      return ['LIABILITY'];
    case AccountingClassification.REVENUE:
      return ['REVENUE'];
    case AccountingClassification['P&L']:
      return ['OTHER_EXPENSE', 'OTHER_INCOME'];
    default:
      // Legacy decisions without COST: keep both cost and expense GL accounts in scope.
      return ['COGS', 'EXPENSE'];
  }
}
